import { initial_state } from './initial_state'

export default (state = initial_state, action) => {
    switch (action.type) {
        // Auth
        case 'AUTH__SET':
            state = {
                ...state,
                is_auth: action.payload,
            }
            break
        case 'AUTH__LOGIN_REFRESH':
            state = {
                ...state,
                is_auth: true,
                user: action.payload.user,
                token: action.payload.token,
            }

            localStorage.setItem('user', JSON.stringify(state.user))
            localStorage.setItem('token', JSON.stringify(state.token))
            break
        case 'AUTH__LOGOUT':
            state = {
                ...state,
                is_auth: false,
                user: initial_state.user,
                user_details: initial_state.user_details,
                user_subscription: initial_state.user_subscription,
                user_subscriptions: initial_state.user_subscriptions,
                user_subscription_constraints: initial_state.user_subscription_constraints,
                token: initial_state.token,
            }

            localStorage.removeItem('user')
            localStorage.removeItem('token')
            break
        // User
        case 'USER__SET':
            state = {
                ...state,
                user: action.payload,
            }
            break
        case 'USER__SET_DETAILS':
            state = {
                ...state,
                user_details: action.payload,
            }
            break
        case 'USER__UPDATE_DETAILS':
            state = {
                ...state,
                user_details: {
                    ...state.user_details,
                    ...action.payload,
                },
            }
            break
        case 'USER__SET_SUBSCRIPTION':
            state = {
                ...state,
                user_subscription: action.payload,
            }
            break
        case 'USER__SET_SUBSCRIPTION_CONSTRAINTS':
            state = {
                ...state,
                user_subscription_constraints: action.payload,
            }
            break
        case 'USER__SET_SUBSCRIPTIONS':
            state = {
                ...state,
                user_subscriptions: action.payload,
            }
            break
        case 'USER__SET_NOTIFICATIONS':
            state = {
                ...state,
                user_notifications: action.payload,
            }
            break
        case 'USER__SET_TRIAL_COUNT':
            state = {
                ...state,
                user_trial_count: action.payload,
            }
            break
        // Products
        case 'PRODUCTS__SET':
            state = {
                ...state,
                products: action.payload.products,
            }
            break
        // Merchant code
        case 'MERCHANT_CODE__SET':
            state = {
                ...state,
                merchantCode: action.payload.merchantCode,
            }
            break
        case 'PROJECT_FEATURES__SET_LIST_OF_AVAILABLE':
            state = {
                ...state,
                project_features: {
                    ...state.project_features,
                    list_of_available: action.payload,
                },
            }
            break
        case 'PROJECT_FEATURES__SET_LIST_OF_DESCRIPTIONS':
            state = {
                ...state,
                project_features: {
                    ...state.project_features,
                    list_of_descriptions: action.payload,
                },
            }
            break
        // Common
        case 'COMMON__SET_APP_LOADED':
            state = {
                ...state,
                app_loaded: action.payload,
            }
            break
        case 'COMMON__SET_LANGUAGE':
            state = {
                ...state,
                language: action.payload,
            }

            localStorage.setItem('lng', action.payload)
            break
        // Token
        case 'TOKEN__SET':
            state = {
                ...state,
                token: action.payload,
            }
            break
        // Service
        case 'SERVICE__SET_NAV_MENU_WIDTH':
            state = {
                ...state,
                _service: {
                    ...state._service,
                    nav_menu_width: action.payload,
                },
            }
            break
        case 'SERVICE__STYLES__SET_HEADER_SIZES':
            state = {
                ...state,
                _service: {
                    ...state._service,
                    styles: {
                        ...state._service.styles,
                        header_width: action.payload.width,
                        header_height: action.payload.height,
                    },
                },
            }
            break
        case 'SERVICE__STYLES__SET_WINDOW_SIZES':
            state = {
                ...state,
                _service: {
                    ...state._service,
                    styles: {
                        ...state._service.styles,
                        window_width: action.payload.width,
                        window_height: action.payload.height,
                    },
                },
            }
            break
        // AssetManager
        case 'ASSET_MANAGER__SET_PROJECT_ID':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    projectId: action.payload.projectId,
                },
            }

            break
        case 'ASSET_MANAGER__MANAGER_SET_TAB':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    managerTab: action.payload.tab,
                },
            }

            break
        case 'ASSET_MANAGER__LIBRARY__UP_IMAGES_PAGE':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        images: {
                            ...state.assetManager.library.images,
                            pageable: {
                                ...state.assetManager.library.images.pageable,
                                pageNumber: state.assetManager.library.images.pageable.pageNumber + 1,
                            },
                        },
                    },
                },
            }

            break
        case 'ASSET_MANAGER__LIBRARY__SET_IMAGES':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        images: action.payload.images,
                    },
                },
            }

            break
        case 'ASSET_MANAGER__LIBRARY__SET_IS_LOAD_IMAGES':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        isLoadImages: action.payload.isLoadImages,
                    },
                },
            }
            break
        case 'ASSET_MANAGER__LIBRARY__SET_IS_LOAD_ERROR':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        isLoadError: action.payload.isLoadError,
                    },
                },
            }
            break
        case 'ASSET_MANAGER__LIBRARY__SET_SELECTED_IMAGE_ID':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        selectedImageId: action.payload.id,
                    },
                },
            }

            break
        case 'ASSET_MANAGER__LIBRARY__SET_SEARCH':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        search: action.payload.search,
                    },
                },
            }

            break
        case 'ASSET_MANAGER__LIBRARY__RESET_LIBRARY':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        ...initial_state.assetManager.library,
                    },
                },
            }
            break
        case 'ASSET_MANAGER__LIBRARY__SET_TAB':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        libraryTab: action.payload.tab,
                    },
                },
            }

            break
        case 'ASSET_MANAGER__MY_LIBRARY__UPLOAD_IMAGE':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        offset: state.assetManager.library.offset + 1,
                        images: {
                            ...state.assetManager.library.images,
                            content: [action.payload.image, ...state.assetManager.library.images.content],
                        },
                    },
                },
            }

            break
        case 'ASSET_MANAGER__MY_LIBRARY__DELETE_IMAGE':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    library: {
                        ...state.assetManager.library,
                        offset: state.assetManager.library.offset - 1,
                        images: {
                            ...state.assetManager.library.images,
                            content: state.assetManager.library.images.content.filter(
                                item => item.originalImageId !== action.payload.id,
                            ),
                        },
                    },
                },
            }
            break
        case 'ASSET_MANAGER__UPDATE_UPLOAD_MEDIA_INFO':
            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    uploadMedia: {
                        ...state.assetManager.uploadMedia,
                        [action.payload.id]: {
                            ...state.assetManager.uploadMedia[action.payload.id],
                            ...action.payload.info,
                        },
                    },
                },
            }

            break
        case 'ASSET_MANAGER__DEL_UPLOAD_MEDIA_INFO':
            const uploadMedia = { ...state.assetManager.uploadMedia }

            delete uploadMedia[action.payload.id]

            state = {
                ...state,
                assetManager: {
                    ...state.assetManager,
                    uploadMedia: {
                        ...uploadMedia,
                    },
                },
            }

            break
        //Editor
        case 'EDITOR__UPDATE_SCREENS': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    screens: action.payload.screens,
                },
            }

            break
        }
        case 'EDITOR__UPDATE_ACTIVE_SCREEN_ID': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    activeScreenId: action.payload.activeScreenId,
                },
            }

            break
        }
        case 'EDITOR__UPDATE_ACTIVE_POPUP_ID': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    activePopupId: action.payload.activePopupId,
                },
            }

            break
        }
        case 'EDITOR__HIDE_POPUP':
        case 'EDITOR__SHOW_POPUP': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    showPopup: action.payload.showPopup,
                },
            }

            break
        }
        case 'EDITOR__SET_PROJECT_TYPE_DATA': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    projectTypeData: action.payload.projectTypeData,
                },
            }

            break
        }
        case 'EDITOR__SET_PROJECT_TYPE': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    projectType: action.payload.projectType,
                },
            }

            break
        }
        case 'EDITOR__ENABLE_POPUPS':
        case 'EDITOR__DISABLE_POPUPS': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    enablePopups: action.payload.enablePopups,
                },
            }

            break
        }
        case 'EDITOR__MOUNT':
        case 'EDITOR__UNMOUNT': {
            state = {
                ...state,
                editor: {
                    ...state.editor,
                    mounted: action.payload.mounted,
                },
            }

            break
        }
        default:
            break
    }
    return state
}
